import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "./services.module.scss";
import CONSTANTS from "../../config/constants.json";

const InHouseSupport = () => {
  return (
    <Box>
      <Typography className={styles.mainheadings}>Downloads</Typography>
      <Typography className={styles.details}>
        <ul style={{margin:0}}>
          <li><a href={CONSTANTS.DOMAIN_URL +"/hints/seniors/images/insupport/Golden%20Years%20Planning%20for%20HCCC%20Seniors.pdf"} target="_blank" style={{color:"#f05802"}}>Practical Guide to Planning for Golden Years for HCCC Seniors</a></li>
          <li> <a href={CONSTANTS.DOMAIN_URL +"/hints/seniors/images/insupport/ca-ad-form.pdf"} target="_blank" style={{color:"#f05802"}}>Advance Health Care Directive Form</a></li>
          <li><a href={CONSTANTS.DOMAIN_URL +"/hints/seniors/images/insupport/Conversation%20Starter%20Kit%20Scales.pdf"} target="_blank" style={{color:"#f05802"}}> Conversation Starter Kit Scales</a></li>
          <li><a href={CONSTANTS.DOMAIN_URL +"/hints/seniors/images/insupport/ConversationProject-ConvoStarterKit-English.pdf"} target="_blank" style={{color:"#f05802"}}>Conversation Project - Conversation Starter Kit</a></li>
          <li><a href={CONSTANTS.DOMAIN_URL +"/hints/seniors/images/insupport/TakeChargeToolkit.Oct2017.pdf"} target="_blank" style={{color:"#f05802"}}>Take Charge - Your Advance Care Planning Toolkit</a></li>
          <li><a href={CONSTANTS.DOMAIN_URL +"/hints/seniors/images/insupport/What%20to%20Ask%20Your%20Doctor.pdf"} target="_blank" style={{color:"#f05802"}}>What to Ask Your Doctor</a></li>
        </ul>
      </Typography>
      <Typography className={styles.mainheadings}>IHSS Registry</Typography>
      <Typography className={styles.details}>
        You can find IHSS home care workers through this registry. All Registry
        home care workers are pre-screened and will be required to pass a
        criminal background check. Call the Consumer Registry Assistance line:
        <b>510-577-1980</b>
      </Typography>
    </Box>
  );
};

export default InHouseSupport;
